import { Component, Input, OnDestroy, OnInit } from "@angular/core"
import { UserService } from "../../services/user.service"
import { ResourceService } from "../../services/resource.service"
import { Observable, Subject } from "rxjs"
import { IWindowResizeEvent, WindowSizeService } from "../../services/window-size.service"
import { takeUntil, tap } from "rxjs/operators"

@Component({
    selector: "app-experience-toggle",
    templateUrl: "./experience-toggle.component.html",
    styleUrls: ["./experience-toggle.component.scss"],
    standalone: false,
})
export class ExperienceToggleComponent implements OnInit, OnDestroy {
    @Input() canSwitchToStudentExperience: boolean = true
    @Input() isFocusView: boolean = false
    innerWidth: number
    private destroyed$: Subject<void> = new Subject<void>()

    windowResizeEventObservable: Observable<IWindowResizeEvent> =
        this.windowSizeService.resize.pipe(
            takeUntil(this.destroyed$),
            tap((resizeEvent: IWindowResizeEvent) => (this.innerWidth = resizeEvent.innerWidth))
        )

    constructor(
        public userService: UserService,
        private resourceService: ResourceService,
        private windowSizeService: WindowSizeService
    ) {}

    ngOnInit() {
        this.windowResizeEventObservable.subscribe()
    }

    switchUserExperience(isStudent: any, isFocusView: any) {
        if (this.canSwitchToStudentExperience) {
            this.resourceService.switchResourceView(isStudent, isFocusView)
        }
    }

    ngOnDestroy() {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
